<template>
  <div id="kanban">
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import scalseNum from '@/mixins/scalseNum.js'
import common from '@/mixins/common.js'
export default {
  mixins: [common, scalseNum],
  name: 'Kanban',
  props: [

  ],
  data () {
    return {

    }
  },
  computed: {
  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
#kanban
  width  100vw
  height 100vh
  background-color: #fff
  font-size: 20px
  >>> *
        box-sizing: border-box
</style>
